/* RESPONSIBLE TEAM: team-channels */
import type AppService from 'embercom/services/app-service';
import { inject as service } from '@ember/service';
import Route from '@ember/routing/route';
import type RouterService from '@ember/routing/router-service';

export default class IntershopRoute extends Route {
  @service declare appService: AppService;
  @service declare router: RouterService;

  beforeModel() {
    this.router.transitionTo('apps.app.settings.channels.messenger.install', {
      queryParams: { tab: 'web', section: 'web-messenger-setup' },
    });
  }
}
